/**
 * WorkspaceSwitcher component
 * Dropdown for switching between workspaces
 */

import { ChevronDown, Building2 } from 'lucide-react';
import { useState } from 'react';

import { useTranslation } from '@/lib/i18n/hooks/use-translation';

import { useSidebarStore } from '../store/sidebar-store';
import './WorkspaceSwitcher.scss';

export function WorkspaceSwitcher() {
  const { t } = useTranslation('common');
  const isExpanded = useSidebarStore((state) => state.isExpanded);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="workspace-switcher">
      <button
        className="workspace-switcher-button"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        type="button"
        title={!isExpanded ? t('workspace.myWorkspace') : undefined}
      >
        <div className="workspace-switcher-icon-wrapper">
          <Building2 className="workspace-switcher-icon" size={20} strokeWidth={2} />
        </div>
        {isExpanded && (
          <>
            <span className="workspace-switcher-name">{t('workspace.myWorkspace')}</span>
            <ChevronDown
              className={`workspace-switcher-chevron ${isOpen ? 'workspace-switcher-chevron-open' : ''}`}
              size={16}
              strokeWidth={2}
            />
          </>
        )}
      </button>
      {isOpen && isExpanded && (
        <div className="workspace-switcher-dropdown">
          <button className="workspace-switcher-item" type="button">
            {t('workspace.myWorkspace')}
          </button>
          <button className="workspace-switcher-item" type="button">
            + {t('workspace.newWorkspace')}
          </button>
        </div>
      )}
    </div>
  );
}
